module.exports = __webpack_public_path__ + "img/home-banner@0.5x.ba8dae46.jpg";